import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { logoutEverywhere, resetPassword } from "../ApiCalls/authentication";
import { useNavigate } from "react-router-dom";
import mantisLogo from "../Assets/img/mantisBlackLogo.png";
import "./login.scss";
import { useParams } from "react-router-dom";

function ForgotPassword(props) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordConfirmed, setPasswordConfirmed] = useState(false);
  const [loggingOutEverywhere, setLoggingOutEverywhere] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  async function submitLogin(event) {
    event.preventDefault();
    event.stopPropagation();
    if (password.length < 6) {
      alert("El PIN debe tener 6 dígitos");
      return;
    }
    if (password.match(/^[0-9]+$/) == null) {
      alert("El PIN debe contener solo números");
      return;
    }
    if (password !== confirmPassword) {
      alert("Las contraseñas no coinciden");
      return;
    }
    const resetPasswordRes = await resetPassword(token, password);
    if (resetPasswordRes.success) {
      setPasswordConfirmed(true);
    } else {
      alert("Error al cambiar la contraseña");
      console.log(resetPasswordRes);
    }
  }

  async function handleLogoutEverywhere() {
    if (!loggingOutEverywhere) {
      setLoggingOutEverywhere(true);
      const logoutRes = await logoutEverywhere(token);
      console.log(logoutRes);
      if (logoutRes.success) {
        alert("Sesiones cerradas con éxito");
        navigate("/");
      } else {
        alert("Error al cerrar las sesiones");
      }
    }
  }

  return (
    <div style={{ textAlign: "center" }}>
      <img src={mantisLogo} alt="Mantis logo" className="login-mantis-logo" />
      {!passwordConfirmed ? (
        <Form
          noValidate
          onSubmit={(e) => {
            submitLogin(e);
          }}
        >
          <Row
            className={isMobile ? "login-input-row-mobile" : "login-input-row"}
          >
            <Form.Group as={Col}>
              <Form.Label className="login-label">PIN de 6 dígitos</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="PIN"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                maxLength="6"
              />
              <i
                className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                style={{
                  cursor: "pointer",
                  position: "relative",
                  left: "40%",
                  top: "-30px",
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </Form.Group>
          </Row>
          <Row
            className={isMobile ? "login-input-row-mobile" : "login-input-row"}
          >
            <Form.Group as={Col}>
              <Form.Label className="login-label">Confirma tu PIN</Form.Label>
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirma tu PIN"
                value={confirmPassword}
                maxLength={6}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <i
                className={
                  showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"
                }
                style={{
                  cursor: "pointer",
                  position: "relative",
                  left: "40%",
                  top: "-30px",
                }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            </Form.Group>
          </Row>
          <Button type="submit" className="reset-button">
            Confirmar
          </Button>
        </Form>
      ) : (
        <>
          <h2>¡Tu contraseña ha sido cambiada con éxito!</h2>
          <p
            style={{
              marginTop: "20px",
              fontSize: "1.2em",
              textAlign: "center",
            }}
          >
            Ya puedes cerrar esta pestaña y si quieres puedes cerrar sesión en
            todos los dispositivos
          </p>
          <Button
            onClick={() => handleLogoutEverywhere()}
            className="reset-button"
          >
            {loggingOutEverywhere
              ? "Cerrando sesión..."
              : "Cerrar sesión en todos los dispositivos"}
          </Button>
        </>
      )}
    </div>
  );
}

export default ForgotPassword;
